// extracted by mini-css-extract-plugin
export default {"Container":"PaginationButtons_Container__PnVuc"};